var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"breadcrumbsmain",attrs:{"items":_vm.itemsbr,"divider":">","large":""}}),_c('v-card',{staticClass:"mx-auto my-2",attrs:{"max-width":"1000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }